type ApiData<T> = {
  id: string
  attributes: T
}

type BasicStructure = { id: string }
export type FlatAPIData<T> = BasicStructure & T

export function flattenJsonApiResponse<T>(apiObject: ApiData<T>): FlatAPIData<T> {
  return {
    id: apiObject.id,
    ...apiObject.attributes,
  }
}

export function toCurrency(value: number, currencySign: string = '$'): string {
  let string = currencySign + (Math.round(100 * value) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return string
}
